(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7217],{

/***/ 25998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ faq; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./src/components/common/Head.tsx
var Head = __webpack_require__(26718);
// EXTERNAL MODULE: ./src/components/common/MetaTags.tsx
var MetaTags = __webpack_require__(71033);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./src/themes/index.tsx + 3 modules
var themes = __webpack_require__(75159);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./server/api/nlt.ts
var nlt = __webpack_require__(4723);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Faq.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






const Faq = () => {
  const {
    0: faqSingleItems,
    1: setFaqSingleItems
  } = (0,react.useState)([]);
  (0,react.useEffect)(() => {
    async function getFaqs() {
      const faqs = await (0,nlt/* getFaqAutoCompleteItems */.eF)();
      setFaqSingleItems(faqs.data);
    }

    if (!faqSingleItems.length) {
      getFaqs();
    }
  });
  let faqItems = {};
  faqSingleItems.forEach(faqItem => {
    faqItems[faqItem.uri] = faqItems[faqItem.uri] || [];
    faqItems[faqItem.uri].push(_objectSpread({}, faqItem));
  });
  const data = {
    "@context": "https://schema.org/",
    "@type": "FAQPage",
    "mainEntity": Object.keys(faqItems).map(faqUri => ({
      "@type": "Question",
      "url": `https://www.carplanner.com/noleggio-a-lungo-termine/faq/${faqUri}`,
      "name": faqItems[faqUri][0].title,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faqItems[faqUri].map(faqItem => `<p><strong>${faqItem.q || ''}</strong> ${faqItem.a || ''}</p>`).join('')
      }
    }))
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataFaq",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Faq = (Faq);
;// CONCATENATED MODULE: ./pages/noleggio-a-lungo-termine/faq.tsx











const Autocomplete = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(3344), __webpack_require__.e(3292), __webpack_require__.e(9653), __webpack_require__.e(804), __webpack_require__.e(1521), __webpack_require__.e(6350), __webpack_require__.e(3070)]).then(__webpack_require__.bind(__webpack_require__, 63070)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(63070)]
  }
});
const Autopromo = dynamic_default()(() => __webpack_require__.e(/* import() */ 1756).then(__webpack_require__.bind(__webpack_require__, 71756)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(71756)]
  }
});

const FaqNltPage = _ref => {
  let {
    faq,
    searchAutoCompleteItems
  } = _ref;
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  const router = (0,next_router.useRouter)();
  const {
    items,
    highlights
  } = faq;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
    bgColor: "baseBackgroundLight",
    mt: "-2",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* default */.Z, {
      title: t('faqPage:title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
      meta: t('faqPage:meta', {
        returnObjects: true
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(MetaTags/* LinkRel */.M, {
      rel: "canonical",
      href: "https://www.carplanner.com/noleggio-a-lungo-termine/faq"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StructuredData_Faq, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
      textAlign: "center",
      bg: "primaryGreen.50",
      position: "sticky",
      top: "0",
      zIndex: "9",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        maxW: "7xl",
        py: "l",
        mx: "auto",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
          as: "h1",
          fontSize: "2xl",
          fontFamily: "Montserrat-SemiBold",
          color: "baseDark",
          children: t('faqPage:title')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Autocomplete, {
          items: searchAutoCompleteItems.map(item => ({
            label: `${item.q} - ${item.a}`,
            value: `/noleggio-a-lungo-termine/faq/${item.uri}#${item.anchor}`
          })),
          onSelect: selected => router.push(selected),
          placeholder: t('faqPage:placeholder'),
          notFoundText: t('faqPage:notFound'),
          mt: "l",
          mx: "auto",
          w: "50%",
          minW: "300px"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
      maxW: "7xl",
      py: "l",
      mx: {
        base: 'l',
        md: 'auto'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1.375rem",
        color: "baseDark",
        textAlign: "left",
        children: t('faqPage:highlights')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Grid */.rj, {
        templateColumns: {
          base: '1fr',
          md: 'repeat(4, 1fr)'
        },
        gap: {
          base: '3',
          md: '6'
        },
        pt: "l",
        children: highlights.map(highlight => /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Autopromo, {
            item: {
              code: highlight.anchor,
              layout: 'solid',
              title: highlight.q,
              text: ' ',
              link: `/noleggio-a-lungo-termine/faq/${highlight.uri}#${highlight.anchor}`,
              linkText: 'Visualizza FAQ',
              image: highlight.image || '/icons/icon_customer.svg'
            }
          })
        }, `${highlight.uri}${highlight.anchor}`))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
        my: "xl"
      }), items.map(item => /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        borderRadius: "10",
        bg: "baseWhite",
        p: "l",
        my: "s",
        borderWidth: "1px",
        borderColor: themes/* theme.colors.borders.grey */.r.colors.borders.grey,
        boxShadow: themes/* theme.shadows.cards */.r.shadows.cards,
        textAlign: "left",
        cursor: "pointer",
        onClick: () => window.location.href = `/noleggio-a-lungo-termine/faq/${item.uri}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
          fontFamily: "Montserrat-SemiBold",
          mr: "l",
          children: item.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
          float: "right",
          mt: "-8",
          fontSize: "2xl",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* ArrowForwardIcon */.mr, {})
        })]
      }, `${item.uri}`))]
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ var faq = (FaqNltPage);

/***/ }),

/***/ 26718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18132);
/* harmony import */ var src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34755);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const Head = _ref => {
  let {
    title
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("title", {
      children: [title || t('common:header.title'), ' ', "| CarPlanner"]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Regular.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Medium.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-SemiBold.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .image */ .BH
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .boxes[0].image */ .qk[0].image
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .boxes[1].image */ .qk[1].image
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Head);

/***/ }),

/***/ 71033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ LinkRel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const isMetaTag = value => {
  if (!value || typeof value !== 'object') return false;
  const tag = value;
  const hasNameOrProperty = typeof tag.name === 'string' || typeof tag.property === 'string';
  if (!hasNameOrProperty) return false;
  const contentOk = tag.content === undefined || typeof tag.content === 'string';
  const overrideOk = tag.override === undefined || typeof tag.override === 'string';
  return contentOk && overrideOk;
};

const normalizeMeta = meta => {
  if (!meta) return [];

  if (Array.isArray(meta)) {
    return meta.filter(isMetaTag);
  }

  if (isMetaTag(meta)) {
    return [meta];
  }

  if (typeof meta === 'object') {
    return Object.values(meta).filter(isMetaTag);
  }

  return [];
};

const MetaTags = _ref => {
  let {
    meta
  } = _ref;
  const tags = normalizeMeta(meta);
  if (tags.length === 0) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: tags.map((tag, index) => {
      const content = tag.override && tag.override.trim() !== '' ? tag.override : tag.content ?? '';
      const key = tag.name ?? tag.property ?? `meta-${index}`;

      if (tag.name) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
          name: tag.name,
          content: content
        }, key);
      }

      if (tag.property) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
          property: tag.property,
          content: content
        }, key);
      }

      return null;
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);
const LinkRel = _ref2 => {
  let {
    rel,
    href,
    crossOrigin,
    type,
    as
  } = _ref2;
  let url = '';

  if (rel === 'canonical' && href.indexOf('?') >= 0) {
    // rimuove eventuali parametri querystring
    url = href.split('?')[0] ?? '';
  } else {
    url = href;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: rel,
      href: url,
      crossOrigin: crossOrigin || null,
      type: type || null,
      as: as || null
    })
  });
};

/***/ }),

/***/ 25366:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noleggio-a-lungo-termine/faq",
      function () {
        return __webpack_require__(25998);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34755:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TN":"Lasciati guidare verso\\nla scelta dell’auto migliore","BH":"https://static1.carplanner.com/website/assets/index-head.jpg","Oc":"CarPlanner ti propone le offerte di auto nuove più competitive\\nsul mercato sia per l’acquisto che per il Noleggio a Lungo Termine","qk":[{"image":"https://static1.carplanner.com/website/assets/noleggia-la-tua-auto-a-lungo-termine-2.png","title":"Noleggia la tua auto a lungo termine","description":"Cerchi un’alternativa all’acquisto di un’auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/noleggio-a-lungo-termine","alt":"Offerte noleggio a lungo termine","target":"_self"},{"image":"https://static1.carplanner.com/website/assets/acquista-la-tua-nuova-auto-online-2.png","title":"Acquista la tua nuova auto online","description":"Cerchi la tua\\nnuova auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/offerte-auto","alt":"Offerte auto in vendita","target":"_self"}],"PX":{"a":"Contattaci ora"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3382,9774,2888,179], function() { return __webpack_exec__(25366); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);